import { useTranslation } from "react-i18next";
import { Button, FoodsIcon } from "@foodpilot/foods";

type PermissionPopoverProps = {
    onClick: () => void;
};

export const PermissionPopover = (props: PermissionPopoverProps) => {
    const { onClick } = props;
    const { t } = useTranslation();

    return (
        <Button
            variant="primary"
            id="create-permission-button"
            onClick={onClick}
            startIcon={<FoodsIcon size={2} icon="plus" />}
        >
            {t("settings.permission.create_permission_btn", "Create Permission")}
        </Button>
    );
};
